import { render, staticRenderFns } from "./ToyRentDetails.vue?vue&type=template&id=27f0d1a8"
import script from "./ToyRentDetails.vue?vue&type=script&lang=js"
export * from "./ToyRentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports